;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('ellipsis', EllipsisFilter)

  function EllipsisFilter () {
    return function (input, chars) {
      if (isNaN(chars)) return input
      if (chars <= 0) return ''
      if (!input || input === 'null' || input === 'undefined') {
        return 'Non spécifié'
      }
      if (input && input.length > chars) {
        input = input.substring(0, chars)
        return input + '...'
      }
      return input
    }
  }
})(window.angular)
